import {Card} from 'antd';
import React, {Suspense} from 'react';
import Highlight, {HighlightProps} from 'react-highlight';
import styled from 'styled-components';
import './Code.css';

export const CodeHighlight = styled(Highlight)`
  font-size: 12px;
  background: #fff !important;
`;

export const Code: React.FC<HighlightProps> = (props) => {
  return (
    <Suspense fallback={<Card loading bodyStyle={{background: '#f5f7fa'}} />}>
      <CodeHighlight {...props} />
    </Suspense>
  );
};
